export var DateRangeOptions;
(function (DateRangeOptions) {
    DateRangeOptions["ALL"] = "All";
    DateRangeOptions["CURRENT_MONTH"] = "Current Month";
    DateRangeOptions["PREVIOUS_MONTH"] = "Previous Month";
    DateRangeOptions["YEAR_TO_DATE"] = "Year-to-date";
    DateRangeOptions["CUSTOM"] = "Custom";
})(DateRangeOptions || (DateRangeOptions = {}));
//# sourceMappingURL=types.js.map